import planningTranslationsHelper from "../../../../languages/planning-translations.helper";
import {
  GpsPlanEntryRecordsErrorGatewayTimeout,
  GpsPlanEntryRecordsErrorType,
} from "./gps-plan-entry-records-error";

const createTimeoutError = (): GpsPlanEntryRecordsErrorGatewayTimeout => {
  const translations =
    planningTranslationsHelper.getOrderTranslations().driverPlanListing.staging;

  return {
    message: translations.gpsGatewayTimeoutLabel,
    params: {},
    type: GpsPlanEntryRecordsErrorType.GATEWAY_TIMEOUT,
  };
};

const gpsPlanEntryRecordsErrorFactory = {
  createTimeoutError,
};

export default gpsPlanEntryRecordsErrorFactory;
